import React from 'react';
import cx from 'classnames';

import './toggle.css';

interface Props {
    checked: boolean;
    color?: 'primary' | 'secondary';
    disabled?: boolean;
    onChange: OnChange;
    initialValue?: boolean;
    inputId: string;
    label: string | JSX.Element;
    labelClasses?: string;
    size?: 'small' | 'large';
    width?: number;
    boldWhenChecked?: boolean;
}

/**
 * A checkbox styled as a toggle switch.
 * Styling based on: https://www.a11ywithlindsey.com/blog/create-custom-keyboard-accesible-checkboxes
 */
export const Toggle = ({
    boldWhenChecked = false,
    checked,
    color = 'secondary',
    disabled = false,
    onChange,
    inputId,
    label,
    labelClasses,
    size = 'small',
    width,
}: Props): JSX.Element => (
    <div style={{ width }}>
        <input
            id={inputId}
            type="checkbox"
            checked={checked}
            disabled={disabled}
            name={inputId}
            className={cx('toggle', color, size)}
            onChange={onChange}
        />
        <label htmlFor={inputId}>
            <span
                style={{ width }}
                className={cx('truncate', labelClasses, {
                    'font-semibold': boldWhenChecked && checked,
                })}
            >
                {label}
            </span>
        </label>
    </div>
);
